import Axios from "axios";

// Producao e o padrao: sem variavel de ambiente, nada muda.
//
// Antes esta linha era trocada a mao para apontar no localhost, com um
// comentario pedindo "reverter antes de commitar". Nao funcionou: o arquivo
// ficou apontando para http://localhost:5051/api, e um build de producao teria
// saido assim — o painel do cliente inteiro sem API.
//
// REACT_APP_API_URL vive no .env.development.local, que o CRA carrega APENAS no
// `yarn start`; o `yarn build` nao le esse arquivo. Agora esquecer de reverter
// nao quebra nada.
// Cuidado: nao mover isto para o .env.local, que e lido nos DOIS modos.
export const baseURL =
  process.env.REACT_APP_API_URL || "https://m2admin.softkuka.com.br/api";
// local: http://localhost:5051/api   ·   dev: https://m2devadmin.softkuka.com.br/api
export const DEPLOY_URL = "https://m2admin.softkuka.com.br";

const api = Axios.create({
  baseURL,
});

api.interceptors.request.use(async (config: any) => {
  if (window.localStorage.getItem("token")) {
    const token = window.localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
